import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useEffect, useMemo, useState } from 'react'
import apis from '../../../../modules/apis'
import { useAITutorSummaryMembership, useCourseDetail } from '../../../../modules/apis/student/ai-tutor'
import { axiosPost } from '../../../../modules/axiosHelper'
import { APP_SCREEN_NAME } from '../../../../modules/hooks/common/appRouterVars'
import useAppRouter, { sendRouterEvent } from '../../../../modules/hooks/common/useAppRouter'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import { aiTutorStreak } from '../../../../modules/react-query/queryApis'
import urls from '../../../../modules/urls'
import LoadingSpinner from '../../../common/LoadingSpinner'
import { AITutorEnterLesson } from '../Common'
import DoneDefault from './DoneDefault'
import DoneStreak from './DoneStreak'

const Done = ({ startTime, endTime, lesson }) => {
  const [curr, setCurr] = useState('default')
  const [streak, setStreak] = useState(null)
  const queryClient = useQueryClient()
  const { data: courseData } = useCourseDetail(lesson?.ai_tutor_course_id)
  const { data: aiTutorMembershipData } = useAITutorSummaryMembership('curriculum')
  const getFullUrl = useReturnFullUrl()
  const isWebview = useIsWebview()

  useEffect(() => {
    if (!endTime) return
    console.log('endTime', endTime)
    axiosPost(apis.aiTutor.streak()).then((r) => {
      console.log(r)
      console.log(r || { streak: { streak: 1, last_date: Date.now() }, updated: true })
      setStreak(r || { streak: { streak: 1, last_date: Date.now() }, updated: true })
      queryClient.invalidateQueries(aiTutorStreak.getQueryKey())
    })
  }, [endTime])

  const router = useAppRouter()

  const nextLessonId = useMemo(() => {
    const lessons = courseData?.course?.units
      ?.map((unit) => unit.lessons)
      ?.flat()
      ?.map((lesson) => lesson.id)
    const nextLessonIdx = lessons?.indexOf(lesson?.id) + 1
    if (nextLessonIdx >= lessons?.length) return null
    return lessons?.[nextLessonIdx]
  }, [courseData, lesson])

  const exit = () => {
    if (isWebview) {
      router.replace(urls.webview.aiTutor.index(), {
        appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
        appSendData: {
          url: getFullUrl(urls.webview.aiTutor.index()),
        },
      })
    } else {
      router.push(urls.webview.aiTutor.index(), {
        appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
        appSendData: {
          url: getFullUrl(urls.webview.aiTutor.index()),
        },
      })
    }
    sendRouterEvent({
      nav: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
    })
  }

  useEffect(() => {
    if (!streak) return
    if (streak.updated) setCurr('streak')
  }, [streak])

  const close = useCallback(() => {
    if (!streak) return
    exit()
  }, [curr, streak])

  const onClickNextLesson = (onClick) => {
    if (aiTutorMembershipData?.is_trial) {
      if (aiTutorMembershipData?.success) {
        // back to course
        sendRouterEvent({
          nav: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
        })
        router.push(urls.webview.aiTutor.index(null, 0), {
          appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
          appSendData: { url: getFullUrl(urls.webview.aiTutor.index(null, 1)) },
        })
      } else {
        // roleplay
        sendRouterEvent({
          nav: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
        })
        router.push(urls.webview.aiTutor.index(null, 1), {
          appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
          appSendData: { url: getFullUrl(urls.webview.aiTutor.index(null, 1)) },
        })
      }
    } else {
      // alert(nextLessonId)
      nextLessonId ? onClick() : close()
    }
  }

  return (
    <AITutorEnterLesson
      lessonId={nextLessonId}
      replace
      comp={(onClick) =>
        streak ? (
          curr === 'default' ? (
            <DoneDefault
              duration={endTime - startTime}
              lessonId={lesson?.id}
              close={close}
              nextLesson={() => onClickNextLesson(onClick)}
            />
          ) : (
            <DoneStreak streak={streak} close={close} nextLesson={() => onClickNextLesson(onClick)} />
          )
        ) : (
          <div className="flex flex-1 items-center justify-center">
            <LoadingSpinner lg show primary />
          </div>
        )
      }
    />
  )
}

export default Done
